import { GET_SPEECH_REQUESTED, GET_SPEECH_SUCCESS, GET_SPEECH_FAILURE } from './speech.constants'
import API from './speech.api'

export const getSpeech = (ccrid, opts) => {
  return async dispatch => {
    dispatch(getSpeechRequested())
    try {
      const speechData = await API.getPhoneticPhraseHits(ccrid, opts)
      dispatch(getSpeechSuccess(speechData))
    } catch (error) {
      dispatch(getSpeechFailure(error))
    }
  }
}

export const getSpeechRequested = () => ({
  type: GET_SPEECH_REQUESTED,
})

export const getSpeechSuccess = data => ({
  type: GET_SPEECH_SUCCESS,
  data,
})

export const getSpeechFailure = error => ({
  type: GET_SPEECH_FAILURE,
  error,
})
